import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthTokenService } from '../core/services/auth-token.service';
import { BYPASS_AUTH } from '../core/http/http-context.tokens';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(BYPASS_AUTH)) return next(req);
  if (req.headers.has('Authorization') || req.headers.has('x-auth-token')) {
    return next(req);
  }

  const raw = inject(AuthTokenService).getToken() || '';
  if (!raw) return next(req);

  const value = raw.startsWith('token:') ? raw : `token:${raw}`;
  return next(req.clone({ setHeaders: { Authorization: value } }));
};
